import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.css']
})
export class NotfoundComponent implements OnInit {

  constructor(public location: Location) {}

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/notfound/notfound.component.ts